<ion-button [disabled]="disabled" (click)="action()">
    <span *ngIf="!loading">{{label}}</span>
    <ion-spinner *ngIf="loading" name="dots" color="secondary"></ion-spinner>
</ion-button>
